import findIndex from "lodash.findindex";

export default function getLibraryIndex(arr, libraryName) {
	return findIndex(arr, el => el.name === libraryName);
}
